import validate from "/app/node_modules/.pnpm/nuxt@3.13.2_@netlify+blobs@9.1.2_@parcel+watcher@2.5.1_@types+node@20.19.11_db0@0.3.2_e_d17ff237ee28eae03d01d616caba04bc/node_modules/nuxt/dist/pages/runtime/validate.js";
import redirects_45global from "/app/.app/middleware/redirects.global.ts";
import manifest_45route_45rule from "/app/node_modules/.pnpm/nuxt@3.13.2_@netlify+blobs@9.1.2_@parcel+watcher@2.5.1_@types+node@20.19.11_db0@0.3.2_e_d17ff237ee28eae03d01d616caba04bc/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  redirects_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {}